import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import { FormViewController } from "../../../../../records/forms/formView/controller";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../records/forms/formView/service";
import fieldHelpers from "../../../../../ui-formly/fieldHelpers";
import { SoftwareUpdateSoftwareListController } from "./softwareList/controller";
import { MachineConfigurationSoftware } from "../../../models/machineConfiguration";

export interface IMultipleSoftwareUpgradeFormModel {
  MachineConfigurationSoftwareIds: number[];
  MachineConfigurationSoftware: MachineConfigurationSoftware;
}

export class MachinesSoftwareUpgradeViewController implements IOnInit {
  static $inject = [FormViewServiceName, "$state", "$stateParams"];

  readonly formFields: IFieldArray;

  /* start bindings */
  readonly model!: IMultipleSoftwareUpgradeFormModel;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    $stateParams: StateParams
  ) {
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "MachineConfigurationSoftware.Software",
            name: "MachineConfigurationSoftware.Software",
            label: "Software",
            className: "col-xs-6",
          }),
          fieldHelpers.simpleStringField({
            key: "MachineConfigurationSoftware.Version",
            name: "MachineConfigurationSoftware.Version",
            label: "Version",
          }),
        ],
        4
      ),
      {
        template: require("!html-loader!./softwareList/index.html").default,
        controller: SoftwareUpdateSoftwareListController,
        key: "softwares",
        model: $stateParams,
      },
    ];
  }

  $onInit(): void {}

  async submit(formViewController: FormViewController): Promise<void> {
    await this.formViewService.submitForm({
      url: `/api/machines/machinesSoftwareUpgrade`,
      formObject: this.model,
      formViewController,
      method: "post",
    });

    await this.$state.go("^", undefined, { reload: true });
  }

  async cancel(): Promise<void> {
    await this.$state.go("^", undefined, { reload: true });
  }
}
